import React from 'react';
import AnalysisPropertyRow from '@/features/datasets/components/DataCollection/dataOverview/sections/AnalysisPropertyRow';

/**
 * "# of Examples" stat row — left column of ObjectiveAnalysisBody (Figma).
 * Label: base-regular / primary; value: base-semibold / primary.
 */
const MetricsRow = ({ examples }) => {
    const value = Number.isFinite(examples) ? examples : 0;
    return (
        <AnalysisPropertyRow
            icon="database"
            label="# of Examples"
            value={value.toLocaleString()}
        />
    );
};

export default MetricsRow;
